var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-gpt-content"},[_c('ai-header'),_c('ai-hero'),_c('ai-advantages'),_c('ai-simple'),_c('ai-question'),_c('ai-how-work'),_c('ai-faq'),_c('ai-popular'),_c('ai-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }